import { IInfo } from "@/androidPlugins/IInfo"
import { IPreferences } from "@/androidPlugins/IPreferences"

const FIRST_INSTALLED_VERSION_KEY = "firstInstalledVersion"
const ACKNOWLEDGED_VERSION_KEY = "acknowledgedVersion"
const LAST_SEEN_VERSION_KEY = "lastSeenVersion"
const PREVIOUS_VERSION_KEY = "previousVersion"

export const useAppUpdate = () => {
  const showAppUpdatedNotification = ref(false)
  const previousVersion = ref<string | null>()
  const acknowledgeUpdate = async (
    version: string | undefined
  ) => {
    if (version === undefined) return

    showAppUpdatedNotification.value = false

    await IPreferences.set({
      key: ACKNOWLEDGED_VERSION_KEY,
      value: version,
    })
  }

  onMounted(async () => {
    const { value: acknowledgedVersion } =
      await IPreferences.get({
        key: ACKNOWLEDGED_VERSION_KEY,
      })

    const { value: lastSeenVersion } =
      await IPreferences.get({
        key: LAST_SEEN_VERSION_KEY,
      })

    const { value: currentVersion } =
      await IInfo.getAppVersion()

    if (lastSeenVersion === null) {
      await IPreferences.set({
        key: FIRST_INSTALLED_VERSION_KEY,
        value: currentVersion,
      })
    }

    if (
      lastSeenVersion !== null &&
      lastSeenVersion !== currentVersion
    ) {
      await IPreferences.set({
        key: PREVIOUS_VERSION_KEY,
        value: lastSeenVersion,
      })
    }

    await IPreferences.set({
      key: LAST_SEEN_VERSION_KEY,
      value: currentVersion,
    })

    const { value: storedPreviousVersion } =
      await IPreferences.get({
        key: PREVIOUS_VERSION_KEY,
      })
    previousVersion.value = storedPreviousVersion

    const { value: firstInstalledVersion } =
      await IPreferences.get({
        key: FIRST_INSTALLED_VERSION_KEY,
      })

    if (
      currentVersion != firstInstalledVersion &&
      currentVersion !== acknowledgedVersion
    ) {
      showAppUpdatedNotification.value = true
    }
  })

  return {
    showAppUpdatedNotification: readonly(
      showAppUpdatedNotification
    ),
    previousVersion: readonly(previousVersion),
    acknowledgeUpdate,
  }
}
